<template>
    <or-layout>
        <a-row :gutter="[16,16]" type="flex" justify="space-between">
            <a-col :span="5">
            </a-col>
            <a-col>
                <a-form layout="inline">
                    <a-form-item>
                        <a-select v-model="searchFrom.campus_id" placeholder="校区" style="width: 150px;" allow-clear>
                            <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{item.name}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 220px;" allow-clear>
                            <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{item.name}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.opening" placeholder="开班状态" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">未开班</a-select-option>
                            <a-select-option :key="1" :value="1">已开班</a-select-option>
                            <a-select-option :key="2" :value="2">已结班</a-select-option>
                        </a-select>
                    </a-form-item>
                    
                    <a-form-item>
                        <a-select v-model="searchFrom.semester_name" placeholder="季度" allow-clear style="width: 80px;">
                              <a-select-option :key="-1" value="">全部</a-select-option>
                            <a-select-option :key="0" value="寒假">寒假</a-select-option>
                            <a-select-option :key="1" value="春季" >春季</a-select-option>
                            <a-select-option :key="2" value="暑假">暑假</a-select-option>
                            <a-select-option :key="3" value="秋季">秋季</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.year_name" placeholder="年度" allow-clear style="width: 90px;">
                             <a-select-option :key="-1" value="">全部</a-select-option>
                            <a-select-option :key="0" value="2021">2021年</a-select-option>
                               <a-select-option :key="1" value="2020">2020年</a-select-option>
                        </a-select>
                    </a-form-item>
                    <!-- <a-form-item>
                        <a-select v-model="searchFrom.user_type" placeholder="老师/班主任" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">老师</a-select-option>
                            <a-select-option :key="1" :value="1">班主任</a-select-option>
                        </a-select>
                    </a-form-item> -->
                    <a-form-item>
                        <a-select v-model="searchFrom.type" placeholder="班型" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">培优</a-select-option>
                            <a-select-option :key="1" :value="1">提高</a-select-option>
                            <a-select-option :key="2" :value="2">英才</a-select-option>
                            <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
                        <a-select-option :key="4" :value="4">体验课</a-select-option>
						  <a-select-option :key="5" :value="5">冲刺班</a-select-option>
                        </a-select>
                    </a-form-item>
                    
                    <a-form-item>
                        <a-input placeholder="班级名称" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-form-item>
                            <a-select mode="multiple" v-model="searchFrom.missiontype_id" placeholder="任务类型" style="width: 220px;"
                                allow-clear>
                                <a-select-option v-for="(item) in MissiontypeList" :key="item.id" :value="item.id">{{item.name}}
                                </a-select-option>
                            </a-select>
                        </a-form-item>

                    </a-form-item>
                    <a-form-item>
                        <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" :placeholder="['任务开始时间', '任务结束时间']"
                            @ok="onChange" />
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                    </a-form-item>
                    <a-form-item>
                       <a-switch v-model="isshowmission" />
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <a-divider></a-divider>
        <div>
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="表格">
                    <a-table :dataSource="missionlist" v-if="isshowmission" :pagination="pageinfo" :loading="loading"
                        @change="onPaginationChange" bordered>
                        <a-table-column key="gradename" title="年级">
                            <template slot-scope="item">
                               {{item.gradename}}
                            </template>
                        </a-table-column>
                        <a-table-column key="missionname" title="任务名">
                            <template slot-scope="item">
                               {{item.missionname}}
                            </template>
                        </a-table-column>
                        <a-table-column key="missiontypename" title="任务类型">
                            <template slot-scope="item">
                               {{item.missiontypename}}
                            </template>
                        </a-table-column>
                    </a-table>
                     <a-divider></a-divider>
                    <a-table :dataSource="tabledata" :pagination="pageinfo" :loading="loading"
                        @change="onPaginationChange" bordered>
                        <a-table-column key="name" title="名字">
                            <template slot-scope="item">
                                {{item.grade_name}}{{item.campusname}}{{item.name}}
                            </template>
                        </a-table-column>
                        <a-table-column key="nickname" title="名字">
                            <template slot-scope="item">
                                {{item.nickname}}
                            </template>
                        </a-table-column>
                        
                        <a-table-column key="squad_student_cnt" title="总人次" data-index="squad_student_cnt" :sorter="(item1, item2) => item1.squad_student_cnt - item2.squad_student_cnt"/>
                        <a-table-column key="squad_student_arrive" title="正常参测人次" data-index="squad_student_arrive" :sorter="(item1, item2) => item1.squad_student_arrive - item2.squad_student_arrive"/>
                        <a-table-column key="squad_student_actual" title="实际参测人次" data-index="squad_student_actual" :sorter="(item1, item2) => item1.squad_student_actual - item2.squad_student_actual"/>

                        <a-table-column key="problems_cnt" title="已做题目数" data-index="problems_cnt" :sorter="(item1, item2) => item1.problems_cnt - item2.problems_cnt"/>
                        <a-table-column key="problems_correct" title="已批改题目数" data-index="problems_correct" :sorter="(item1, item2) => item1.problems_correct - item2.problems_correct"/>
                        <a-table-column key="sjccl" title="实际参测率" :sorter="(item1, item2) => parseFloat(item1.squad_student_actual/item1.squad_student_cnt).toFixed(2) - parseFloat(item2.squad_student_actual/item2.squad_student_cnt).toFixed(2)">
                            <template slot-scope="item">
                                {{parseFloat(item.squad_student_actual/item.squad_student_cnt).toFixed(2)}}
                            </template>
                        </a-table-column>
                        <a-table-column key="sjccl" title="实际应参测率" :sorter="(item1, item2) => parseFloat(item1.squad_student_actual/item1.squad_student_arrive).toFixed(2) - parseFloat(item2.squad_student_actual/item2.squad_student_arrive).toFixed(2)">
                            <template slot-scope="item">
                                {{parseFloat(item.squad_student_actual/item.squad_student_arrive).toFixed(2)}}
                            </template>
                        </a-table-column>

                        <a-table-column key="sjpgl" title="实际批改率" :sorter="(item1, item2) => parseFloat(item1.problems_correct/item1.problems_cnt).toFixed(2) - parseFloat(item2.problems_correct/item2.problems_cnt).toFixed(2)">
                            <template slot-scope="item">
                                 <a-progress :percent="parseFloat((item.problems_correct/item.problems_cnt*100).toFixed(2))" status="active" /> <!-- {{parseFloat(item.problems_correct/item.problems_cnt).toFixed(2)}} -->
                            </template>
                        </a-table-column>

                        <!--  <a-table-column key="nocc" title="不参测" data-index="nocc" /> -->
                        <!-- <a-table-column key="statistic" title="正常参测" data-index="statistic" />
                   
                        <a-table-column key="banzhuren" title="班主任" data-index="banzhuren" />
                        <a-table-column key="teacher" title="任课老师" data-index="teacher" />
                        <a-table-column key="type" title="班型">
                            <template slot-scope="item">
                                <span v-if="item.type==0">培优班</span>
                                <span v-if="item.type==1">提高班</span>
                                <span v-if="item.type==2">英才班</span>
                                <span v-if="item.type==3">1对1VIP班</span>
                            </template>
                        </a-table-column>
                        <a-table-column key="status" width="100px;" title="状态">
                            <template slot-scope="item">
                                <span v-if="item.status==1">可用</span>
                                <span v-if="item.status==0">已禁用</span>
                            </template>
                        </a-table-column> 
                      -->
                    </a-table>
                </a-tab-pane>

                <a-tab-pane key="2" tab="图表" force-render>
                    <!--    <v-chart :forceFit="true" :height="400" :data="piedata" :scale="scale">
                        <v-tooltip :showTitle="false" dataKey="item*percent" />
                        <v-axis />
                        <v-legend dataKey="item" />
                        <v-pie position="percent" color="item" :v-style="pieStyle" :label="labelConfig" />
                        <v-coord type="theta" />
                    </v-chart> -->

                    <!--  <a-divider></a-divider>
                    <v-chart :forceFit="true" :padding="padding" :height="heightx" :data="chartdata">
                        <v-coord type="rect" direction="LB" />
                        <v-tooltip />
                        <v-legend />
                        <v-axis dataKey="label" label="nickname" />
                        <v-axis dataKey="label" position="right" />
                        <v-stack-bar position="nickname*value" color="type" />
                    </v-chart> -->
                </a-tab-pane>
            </a-tabs>
        </div>
    </or-layout>
</template>

<script>
    import AFormItem from "ant-design-vue/es/form/FormItem";
    
    // const DataSet = require('@antv/data-set');

    export default {
        components: {
            AFormItem
        },
        data() {
            return {
                tabledata: [],
                pageinfo: {
                    total: 1,
                    current: 1,
                    pageSize: 999
                },
                isshowmission:false,
                padding: [10, 80, 50, 100],
                loading: false,
                courseList: [],
                searchFrom: {
                    keyword: undefined,
                    grade_id: undefined,
                    campus_id: undefined,
                    missiontype_id: undefined,
                    type: undefined,
                    start_time: Number,
                    end_time: Number,
                    opening: 1,
                    user_type: 0,
                    semester_name:'寒假',
                    year_name:'2021'
                },
                dataviser: [],
                label: {
                    offset: 12
                },
                campusList: [],
                MissiontypeList: [],
                gradeList: [],
                campuscount: [],
                missionlist:[],
            };
        },
        mounted() {
            this.getCampusList();
            this.getGradeList();
            this.getMissiontypeList();
        },
        computed: {
            /* chartdata() {
                 //  let me = this 
                 const sourceData = [];
                 this.tabledata.forEach(row => {
                       row['不参测人数'] = Number(row['nocc']);
                        row['参测人数'] = Number(row['statisticcount']);
                     sourceData.push(row);
                 });
                 const dv = new DataSet.View().source(sourceData);
                 dv.transform({
                     type: 'fold',
                     fields: ['参测人数', '不参测人数'],
                     key: 'type',
                     value: 'value',
                     retains: ['nickname'],
                 });
                 const dataviser = dv.rows;
                 return dataviser;
             },

           
             heightx() {
                 return this.tabledata.length * 50;
             } */

        },

        methods: {
            getGradeList() {
                this.$axios
                    .post("/api/BasicGrade/index")
                    .then(res => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定"
                            });
                        } else {
                            this.gradeList = res.data.data;
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },

            getMissiontypeList() {
                this.$axios
                    .post("/api/BasicMissionType/index")
                    .then(res => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定"
                            });
                        } else {
                            this.MissiontypeList = res.data.data;
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            onChange(value, dateString) {
                dateString,
                this.searchFrom.start_time = Number(value[0] / 1000);
                this.searchFrom.end_time = Number(value[1] / 1000);
                //this.searchForm.end_time=Number(value[1]/1000);
                // console.log('Selected Time: ', value[1]);
                // console.log('Formatted Selected Time: ', dateString[0]);
            },


            getCampusList() {
                this.$axios
                    .post("/api/admin/getmycampuslist")
                    .then(res => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定"
                            });
                        } else {
                            this.campusList = res.data;
                            this.tableSearch();
                            //  this.getCourseList();
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            changeCampus(e) {
                this.searchForm.campus_id = e;
            },
            onPaginationChange(item) {
                this.pageinfo.current = item.current;
                this.getTableList(this.searchFrom);
            },
            tableSearch() {
                this.pageinfo.current = 1;
                this.getTableList(this.searchFrom);
            },
            getTableList(data) {
                this.loading = true;
                this.$axios
                    .post("/api/AnalyseInfo/getyuxiinfo", {
                        data,
                        pageinfo: this.pageinfo
                    })
                    .then(res => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定"
                            });
                        } else {

                            this.tabledata = res.data.data;
                            this.missionlist = res.data.missionlist;

                        }
                    })
                    .catch(err => {
                        console.error(err);
                    }).finally(() => {
                        this.loading = false;
                    })
            }
        }
    };
</script>
<style>
    .active_btn {
        margin-left: 5px;
    }
</style>
